<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>平台数据</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <div v-loading="loading.loading">

      <el-row class="mt10">
        <el-col :span="16" class="pr5 mb10">
          <el-card>
            <div slot="header" class="clearfix flex space">
              <span class="col45">设备耗能统计</span>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-button-group>
                  <el-button size="mini" :autofocus="true" @click="getIndexAnalysis(1)">本周</el-button>
                  <el-button size="mini" @click="getIndexAnalysis(2)">本月</el-button>
                  <el-button size="mini" @click="getIndexAnalysis(3)">本年</el-button>
                </el-button-group>
              </div>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-date-picker :pickerOptions="pickerOptions" @input="getDateBill" v-model="billDate" size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </div>
            </div>
            <div id="bar" style="width: 100%; height: 300px"></div>
          </el-card>
        </el-col>
        <el-col :span="8" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>设备耗能统计</span>
            </div>
            <div>
              <div id="pie" style="width: 500px; height: 300px;"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row class="mt10">
        <el-col :span="24" class="pr5 mb10">
          <el-card>
            <div slot="header" class="clearfix flex space">
              <span class="col45">光伏数据</span>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-button-group>
                  <el-button size="mini" :autofocus="true" @click="getIndexActive(1)">本周</el-button>
                  <el-button size="mini" @click="getIndexActive(2)">本月</el-button>
                  <el-button size="mini" @click="getIndexActive(3)">本年</el-button>
                </el-button-group>
              </div>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-date-picker :pickerOptions="pickerOptions" @input="getDateBill" v-model="billDate" size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </div>
            </div>
            <div id="line" style="width: 100%; height: 400px"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
<style>
.el-card__header {
  height: 65px;
}
.box-cell {
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
  height: 171px;
  padding: 10px 20px 20px 20px;
  background: url(/img/u122.7b61cf7c.png) no-repeat center 110px;
  background-size: 90%;
  background-color: #fff;
  border-radius: 15px;
}

.box-cell .box-icon {
  background-color: #5ad8a6;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.box-cell .box-title {
  display: flex;
  flex-direction: column;
  width: 54%;
}

.box-cell .box-title .online {
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}

.box-cell .box-title .yestaday {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.box-cell .box-nums {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.box-cell .box-nums .total {
  line-height: 30px;
  font-size: 30px;
}

.box-cell .box-nums .nums {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.gl-count {
  flex: 1;
  text-align: center;
}

.gl-count p:nth-child(1) {
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 16px;
  color: #666;
}

.gl-count p:nth-child(2) {
  font-size: 38px;
  line-height: 35px;
  color: #1676eb;
  font-weight: bold;
}

.gl-count p:nth-child(2):after {
  box-sizing: border-box;
}
</style>
<script>
import countTo from "vue-count-to";
export default {
  components: { countTo },
  data() {
    return {
      billDate: [],
      loading: {
        loading: true,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      online_days: [],
      online_series1: [],
      online_series2: [],
      online_series3: [],
      online_series4: [],
      online_series5: [],
      active_dev: "",
      online_dev: "",
      times_dev: "",
    };
  },
  created() {
    this.loading.loading = false;
  },
  mounted() {
    this.getIndexAnalysis();
    this.getIndexActive();
    this.drawChart2();
  },
  methods: {
    getDateBill() {
      this.getIndexActive();
    },

    getIndexActive(type) {
      const that = this;
      that.axios
        .post("/get_consume_users", {
          type: type,
          times: this.billDate,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.active_dev = res.data.data;
            this.online_dev = res.data.data1;
            this.times_dev = res.data.date;
            this.drawChart1();
            this.loading.loading = false;
          } else {
            this.loading.loading = false;
            that.$message.error(res.msg);
          }
        });
    },

    getIndexAnalysis(type) {
      const that = this;
      that.axios
        .post("/get_consume_datas", {
          type: type,
          times: this.billDate,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.online_series1 = res.data.data1;
            this.online_series2 = res.data.data2;
            this.online_series3 = res.data.data3;
            this.online_series4 = res.data.data4;
            this.online_series5 = res.data.data5;
            this.online_days = res.data.date;
            this.drawChart();
            this.loading.loading = false;
          } else {
            this.loading.loading = false;
            that.$message.error(res.msg);
          }
        });
    },

    drawChart() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("bar"));
      // 指定图表的配置项和数据
      let option = {
        xAxis: {
          data: this.online_days,
        },
        yAxis: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        color: ["#50b5ff", "#8167f5", "#ffc542", "#ff7474", "#8167f5"],
        series: [
          {
            name: "空调",
            type: "bar",
            data: this.online_series1,
            barWidth: "8%",
          },
          {
            name: "照明",
            type: "bar",
            data: this.online_series2,
            barWidth: "8%",
          },
          {
            name: "影音",
            type: "bar",
            data: this.online_series3,
            barWidth: "8%",
          },
          {
            name: "洗衣机",
            type: "bar",
            data: this.online_series4,
            barWidth: "8%",
          },
          {
            name: "其他",
            type: "bar",
            data: this.online_series5,
            barWidth: "8%",
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    drawChart2() {
      let myChart = this.$echarts.init(document.getElementById("pie"));

      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 80,
          bottom: 20,
          formatter: function (name) {
            var total = 0;
            for (var i = 0; i < option.series[0].data.length; i++) {
              total += option.series[0].data[i].value;
            }
            for (i = 0; i < option.series[0].data.length; i++) {
              var dpercent =
                ((option.series[0].data[i].value / total) * 100).toFixed(2) +
                "%";
              if (option.series[0].data[i].name === name) {
                //可以显示名称和值和百分比
                // return name+’ ‘+option.series[0].data[i].value+’’+dpercent;
                //只显示名称和百分比
                return name + " " + dpercent;
              }
            }
          },
        },
        color: ["#50b5ff", "#8167f5", "#ffc542", "#ff7474", "#8167f5"],
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 26,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 100, name: "空调" },
              { value: 120, name: "照明" },
              { value: 142, name: "影音" },
              { value: 108, name: "洗衣机" },
              { value: 178, name: "其他" },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },

    drawChart1() {
      console.log(this.times_dev);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("line"));
      // 指定图表的配置项和数据
      let option = {
        tooltip: {},
        color: ["#3998fc", "#b2f549"],
        legend: {
          data: ["发电量", "耗电量"],
        },
        xAxis: {
          data: this.times_dev,
        },
        yAxis: {},
        series: [
          {
            name: "发电量",
            type: "line",
            data: this.online_dev,
            smooth: true,
          },
          {
            name: "耗电量",
            type: "line",
            data: this.active_dev,
            smooth: true,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>
